export default __webpack_public_path__ + "static/landing-section-3-img-4-749c7e454701d7d285779bade0ccb156.png";